import { IScheduleRange } from '../../models';

export function scheduleRangeInsideOther(outer: IScheduleRange, expectedInner: IScheduleRange): boolean {
  return expectedInner.begin >= outer.begin && expectedInner.end <= outer.end;
}
